module.exports = __webpack_public_path__ + "img/banner.34cb8988.png";